<template>
    <div class="container" v-show="pageState === 2">
        <div class="image-container"
          v-for="item in sourceData.guides"
          :key="item">
            <img class="image-guide" :src="item" />
        </div>
        <div class="empty"></div>
        <div class="empty" v-if="!isIos"></div>
        <!-- <div class="download-btn-wrap position-open" v-if="!isIos">
            <div class="download-btn" data-dp-track="click"
            data-dp-attrs="download:open"
            @click="handleOpenBtnClick">
              {{`打开${appName}`}}
            </div>
        </div> -->
        <div class="download-btn-wrap">
            <div class="download-btn btn-copy" 
              data-dp-track="click"
              :data-dp-attrs="`download:download;uuid:${uuid}`"
              :data-clipboard-text="copyText"
              @click="handleDownloadBtnClick"
            >
              立即下载{{ latestAppVersion ? '（v' + latestAppVersion + '）' : ''}}
            </div>
            <div class="privacy-policy">
              <div
                class="privacy-policy__checkbox"
                :class="{'privacy-policy__checkbox--checked': isChecked}"
                @click="handleClick"
              ></div>
              <div class="privacy-policy__content">
                我已阅读并同意
                <a
                  :href="userServiceUrl"
                  target="_blank"
                  class="link"
                >《用户服务协议》</a>
                <a
                  :href="userPrivacyUrl"
                  target="_blank"
                  class="link"
                >《用户隐私协议》</a>
                和
                <a
                  :href="childPrivacyUrl"
                  target="_blank"
                  class="link"
                >《儿童用户隐私政策》</a>
                ，用户终端权限列表及用途等信息详见以上协议
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';

import { QS } from '../utils/queryString';
import { isRunInWeChat, isRunInQQ } from '../utils/env';

const qs = QS();
const downloadUrl = qs.getValue('download_url');
const iosUrl = qs.getValue('ios_url');
const androidUrl = qs.getValue('android_url');
const routerUrl = qs.getValue('router_url');
const dpId = qs.getValue('dpid');

Vue.use(Toast);

export default {
  name: 'Downloadnew',
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pageState: 0, // 页面状态，0 => 默认无状态，1 => loading，2 => ok，3 => wrong|empty
      url: '',
      autoDownloadTm: -1,
      copyText: '',

      latestAppVersion: '',

      isChecked: false,

      // Android
      userServiceUrl: 'https://ssweb.knowbox.cn/web4activity/feed_agreement/service.html',
      userPrivacyUrl: 'https://ssweb.knowbox.cn/web4activity/feed_agreement/aiclass-privacy.html',
      childPrivacyUrl: 'https://ssweb.knowbox.cn/protocol/protocol-classroom-child-Android.html'
    };
  },
  computed: {
    uuid() {
      return window.localStorage.getItem("kb_uuid") || "";
    },
    isIos() {
      return this.platform === 'ios';
    },
    targetSource() {
      const path = window.location.pathname;
      let result = '';
      if (/parent/.test(path)) {
        result = 'parent';
      } else if (/student/.test(path)) {
        result = 'student';
      } else if (/teacher/.test(path)) {
        result = 'teacher';
      } else if (/box/.test(path)) {
        result = 'box';
      }
      return result;
    },
    packageKey() {
      const map = {
        parent: 'par',
        student: 'stu',
        teacher: 'tea',
        box: 'cla',
      };
      const os = this.isIos ? 'ios' : 'and';
      return `${os}${map[this.targetSource]}`;
    },
    appName() {
      switch (this.targetSource) {
        case 'parent':
          // return '小盒课堂';
          return '小盒学习';
        case 'student':
          return '小盒学生';
        case 'teacher':
          return '小盒老师';
        case 'box':
          return '小盒课堂';
        default:
          return '';
      }
    },
    sourceData() {
      let result = {};
      switch (this.targetSource) {
        case 'parent':
          result = {
            logo:
              'https://appd.knowbox.cn/ss/app-icon/xhkt/icon_text_no_slogan_aphpa.png',
            name: '孩子的第二课堂',
            guides: [
              // 'https://appd.knowbox.cn/ss/official/download/xhkt/gudie-1.jpg',
              // 'https://appd.knowbox.cn/ss/official/download/xhkt/gudie-2.jpg',
              // 'https://appd.knowbox.cn/ss/official/download/xhkt/gudie-3.jpg',
              'https://susuanqiniu.knowbox.cn/fe/deeplink/xhxx-1.jpg',
              'https://susuanqiniu.knowbox.cn/fe/deeplink/xhxx-2.jpg',
              'https://susuanqiniu.knowbox.cn/fe/deeplink/xhxx-3.jpg',
            ],
          };
          break;
        case 'student':
          result = {
            logo:
              'https://appd.knowbox.cn/ss/app-icon/xhxs/icon_text_alpha.png',
            name: '教.学.练.测 用小盒',
            guides: [
              'https://appd.knowbox.cn/ss/official/download/xhxs/guide-1.jpg',
              'https://appd.knowbox.cn/ss/official/download/xhxs/guide-2.jpg',
              'https://appd.knowbox.cn/ss/official/download/xhxs/guide-3.jpg',
            ],
          };
          break;
        case 'teacher':
          result = {
            logo:
              'https://appd.knowbox.cn/ss/app-icon/xhls/icon_text_alpha.png',
            name: '教.学.练.测 用小盒',
            guides: [
              'https://appd.knowbox.cn/ss/official/download/xhls/guide-1.jpg',
              'https://appd.knowbox.cn/ss/official/download/xhls/guide-2.jpg',
              'https://appd.knowbox.cn/ss/official/download/xhls/guide-3.jpg',
            ],
          };
          break;
        case 'box':
          result = {
            logo:
              'https://appd.knowbox.cn/ss/app-icon/xhkt/icon_text_no_slogan_aphpa.png',
            name: '孩子的第二课堂',
            guides: [
              'https://appd.knowbox.cn/ss/official/download/xhkt/gudie-1.jpg',
              'https://appd.knowbox.cn/ss/official/download/xhkt/gudie-2.jpg',
              'https://appd.knowbox.cn/ss/official/download/xhkt/gudie-3.jpg',
            ],
          };
          break;
        default:
      }
      return result;
    },
  },
  created() {
    this.getCopyText();
    
    let url;
    if (downloadUrl) {
      url = downloadUrl;
    } else if (this.isIos) {
      url = iosUrl;
    } else {
      url = androidUrl;
    }
    if (url) {
      this.url = decodeURIComponent(url);
    } else {
      this.getAppUrl();
    }
    if (!this.isIos) { 
      // 在微信或QQ Android环境，小盒学习App跳应用宝微下载链接地址
      // 例如：https://a.app.qq.com/o/simple.jsp?pkgname=com.knowbox.rc.student.pk&android_schema=prapidcalculation%3A%2F%2Fbusiness%2FopenBukeListenCourseDetail%3FcourseId%3D156%26sectionId%3D6000
      const flag = (isRunInWeChat() || isRunInQQ()) && ['parent', 'box'].includes(this.targetSource);
      if (flag) {
        let yybUrl = '';
        if (this.targetSource === 'parent') {
          yybUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.knowbox.rc.student.pk';
        } else if (this.targetSource === 'box') {
          yybUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.knowbox.androidaiclass';
        }
        if (routerUrl) {
          let tmp = decodeURIComponent(routerUrl);
          const kvs = QS(tmp)._query;
          const arr = [];
          for (let k in kvs) {
            arr.push(`${k}=${kvs[k]}`);
          }
          arr.push(`kbpd=${encodeURIComponent(this.copyText)}`);
          tmp = `${tmp.split('?')[0]}?${arr.join('&')}`;
          yybUrl += `&android_schema=${encodeURIComponent(tmp)}`;
        }
        this.$parent.isShowGuide = false;
        window.loadWebSDK(() => {
          window.websdk.dpExposure({download:"download", uuid: this.uuid});
          setTimeout(() => {
            window.location.href = yybUrl;
          }, 1000);
        });
        return false;
      } else {
        // 如果是android，走一下scheme协议，applink有可能打开失败
        setTimeout(() => {
          this.openAndroidApp(false);
        }, 100);
      }
    }
    this.pageState = 2; // ok
    window.loadWebSDK(() => {
      window.websdk.dpExposure({download:"download"});
    });
    // this.openIOSAppStore(); // 这里iOS会直接打开AppStore，无法点击页面下载按钮，就无法复制，故先去掉

    if (this.isIos) {
      this.userServiceUrl = 'https://ssweb.knowbox.cn/web4activity/feed_agreement/service-iOS.html';
      this.userPrivacyUrl = 'https://ssweb.knowbox.cn/web4activity/feed_agreement/aiclass-privacy-iOS.html?protocolShow=true';
      this.childPrivacyUrl = 'https://ssweb.knowbox.cn/protocol/protocol-classroom-child-IOS.html';
    }

    this.getAppVersion();
  },
  mounted() {
    if (window.ClipboardJS) {
      const clipboard = new window.ClipboardJS('.btn-copy');
  
      clipboard.on('success', (e) => {
          // console.info('Action:', e.action);
          // console.info('Text:', e.text);
          // console.info('Trigger:', e.trigger);

          e.clearSelection();
      });
  
      clipboard.on('error', (e) => {
          // console.error('Action:', e.action);
          // console.error('Trigger:', e.trigger);
      });
    }
  },
  methods: {
    // iOS未安装App情况下跳转App Store
    openIOSAppStore() {
      if (!this.isIos) {
        return false;
      }
      window.location.href = decodeURIComponent(downloadUrl);
    },
    openAndroidApp(download) {
      let dpurl = '';
      if (this.targetSource === 'box') {
        dpurl = `xiaoheketang://cn.knowbox.androidaiclass?router_url=${routerUrl}&dpid=${dpId}`;
      } else {
        dpurl = `knowbox.deeplink${this.targetSource}://deeplink?router_url=${routerUrl}&dpid=${dpId}`;
      }
      this.redirect(dpurl);
      if (download) {
        clearTimeout(Number(this.autoDownloadTm));
        this.autoDownloadTm = setTimeout(() => {
          this.redirect(this.url);
        }, 2000);
      }
    },
    async getAppUrl() {
      const { data: axiosData } = await axios.get(
        'https://stuapi.knowbox.cn/official-web/official-web/get-package-list',
        {
          params: {
            os: this.platform,
            ts: Date.now(),
          },
        },
      );
      const { code, data } = axiosData;
      if (code !== 99999) {
        return;
      }
      try {
        this.url = data[this.packageKey].url;
      } catch (error) {
        this.url = '';
      }
    },
    handleDownloadBtnClick() {
      if (!this.isChecked) {
        Toast('请先阅读《用户服务协议》《用户隐私协议》和《儿童用户隐私政策》');

        return;
      }

      setTimeout(() => {
        this.redirect(this.url);
      }, 300);
    },
    handleOpenBtnClick() {
      this.openAndroidApp(true);
    },
    redirect(appUrl) {
      window.location.href = appUrl;
    },
    // 获取复制文本
    getCopyText() {
      const textArr = [this.uuid, dpId, routerUrl];
      textArr.push(QS(decodeURIComponent(routerUrl)).getValue("uid") || '');

      this.copyText = `kbpd:${textArr.join('|')}`;
    },

    async getAppVersion() {
      try {
        const { data: axiosData } = await axios.get(
          'https://stuapi.knowbox.cn/official-web/official-web/get-package-list',
          {
            params: {
              os: this.platform,
              ts: Date.now(),
            },
          },
        );

        const { code, data } = axiosData;

        if (code !== 99999) {
          return;
        }

        let version;

        if (this.platform === 'ios') {
          version = data.iosnew.version;
        } else {
          version = data.andnew.version;
        }

        this.latestAppVersion = version?.substring(0, 1) + '.' + version?.substring(1, 2) + '.' + version?.substring(2);
      } catch (e) {}
    },

    handleClick() {
      this.isChecked = !this.isChecked;
    }
  },
};
</script>
<style scoped>
.container {
    width: 100%;
    height: 100vw;
    background: url(https://appd.knowbox.cn/ss/official/download/img/ssmob/bg-new.png) center;
    background-size: 100%;
    -webkit-font-smoothing: antialiased;
}
.image-container{
    width: 100%;
}
.image-guide {
    width: 100%;
}
.empty {
    width: 100%;
    height: 18vw;
}
.download-btn-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 35vw;
    background: rgb(255,255,255);
    overflow: hidden;
    padding: 0 5.3vw;
    box-sizing: border-box;
}
.position-open {
  bottom: 18vw;
}
.download-btn {
    width: 89vw;
    margin-top: 2.1vw;
    height: 11.7vw;
    line-height: 11.7vw;
    text-align: center;
    color: #fff;
    background: #FF6016;
    font-family: PingFangSC-Semibold, PingFang SC;
    border-radius: 10.6vw;
    font-size: 4.3vw;
    font-weight: 600;
}

.privacy-policy {
  margin-top: 3.2vw;
  display: flex;
}

.privacy-policy .privacy-policy__checkbox {
  width: 5.8vw;
  height: 5.8vw;
  background: url(https://susuanqiniu.knowbox.cn/fe/deeplink/uncheck.png);
  background-size: cover;
  margin-right: 3.2vw;
}

.privacy-policy .privacy-policy__checkbox.privacy-policy__checkbox--checked {
  background-image: url(https://susuanqiniu.knowbox.cn/fe/deeplink/checked.png);
}

.privacy-policy .privacy-policy__content {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  flex: 1;
}

.privacy-policy .link {
  color: #FF6016;
  line-height: 4.8vw;
  text-decoration: none;
}
</style>
